import { render } from "./PanelTipsterDescuentos.vue?vue&type=template&id=3b207b3e&scoped=true"
import script from "./PanelTipsterDescuentos.vue?vue&type=script&lang=js"
export * from "./PanelTipsterDescuentos.vue?vue&type=script&lang=js"

import "./PanelTipsterDescuentos.vue?vue&type=style&index=0&id=3b207b3e&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b207b3e"]])

export default __exports__